"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activity = void 0;
const index_1 = require("../Base/index");
/**
 * The base class for all activities.
 */
class Activity extends index_1.FlowNode {
}
exports.Activity = Activity;
//# sourceMappingURL=ActivityBase.js.map